import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';

import ModifyContainer from '../ModifyContainer';
import Column from 'components/common/Column';
import Text from 'components/common/Text';
import Divider from 'components/Divider';

import Row from 'components/common/Row';
import {
  InquiryTemplate,
  InquiryTemplateItem,
  ItemInquiryInputKind,
} from 'types/api';
import { ModifyValue } from '../../hooks/useProductDetaillHooks';

interface QuestionContainerIProps {
  isMobile: boolean;
  inquiryList: InquiryTemplate;
  modifyValue: ModifyValue;
  setModifyValue: React.Dispatch<React.SetStateAction<ModifyValue>>;
}

const QuestionContainer: React.FC<QuestionContainerIProps> = props => {
  const { isMobile, inquiryList, modifyValue, setModifyValue } = props;

  const renderInquiryKind = (item: InquiryTemplateItem): JSX.Element => {
    switch (item.inputKind) {
      case ItemInquiryInputKind.TEXT: {
        return (
          <Column gap="4px" align="flex-start">
            <Text weight={400}>답변 유형</Text>
            <Text color="#46474C" size="16px">
              주관식
            </Text>
          </Column>
        );
      }
      default: {
        return (
          <React.Fragment>
            {!isEmpty(item.items) && (
              <Column gap="2px" align="flex-start">
                {item.items.map((selectItem, selectIdx) => {
                  return (
                    <Column gap="4px" align="flex-start" key={selectIdx}>
                      <Text weight={400}>객관식 답변{selectIdx + 1}</Text>
                      <Text color="#46474C" size="16px">
                        {selectItem.label}
                      </Text>
                    </Column>
                  );
                })}
              </Column>
            )}
          </React.Fragment>
        );
      }
    }
  };

  const renderContents = (): JSX.Element => {
    if (isEmpty(inquiryList)) {
      return (
        <Text
          color="#46474C"
          size="16px"
          weight={500}
          style={{ textAlign: 'center', lineHeight: '22px' }}
        >
          등록한 질문이 없어요. <br />
          프립 진행을 위해 크루들로부터 <br />
          추가 정보를 수집해야 할 경우 작성해 보세요.
        </Text>
      );
    }

    if (inquiryList && isEmpty(inquiryList.inquiries)) {
      return (
        <Text
          color="#46474C"
          size="16px"
          weight={500}
          style={{ textAlign: 'center', lineHeight: '22px' }}
        >
          등록한 질문이 없어요. <br />
          프립 진행을 위해 크루들로부터 <br />
          추가 정보를 수집해야 할 경우 작성해 보세요.
        </Text>
      );
    }

    return (
      <Column gap="24px">
        {inquiryList.inquiries.map((inquiryItem, inquiryIdx) => {
          return (
            <React.Fragment key={inquiryIdx}>
              <Column gap="8px" align="flex-start">
                <Column gap="4px" align="flex-start">
                  <Row justifyContent="space-between" style={{ width: '100%' }}>
                    <Text weight={400} style={{ minWidth: '42px' }}>
                      질문{inquiryIdx + 1}
                    </Text>
                  </Row>
                  <Text color="#46474C" size="16px">
                    {inquiryItem.title}
                  </Text>
                </Column>
                {renderInquiryKind(inquiryItem)}
                <Column gap="4px" align="flex-start">
                  <Text weight={400}>답변 필수 여부</Text>
                  <Text color="#46474C" size="16px">
                    {inquiryItem.required
                      ? '필수로 받을게요'
                      : '필수가 아니에요'}
                  </Text>
                </Column>
              </Column>
              {inquiryList.inquiries.length !== inquiryIdx + 1 && <Divider />}
            </React.Fragment>
          );
        })}
      </Column>
    );
  };

  return (
    <ModifyContainer
      title="질문"
      isSelected={!isMobile && modifyValue.modifyStatus === 'question'}
      modifyText={isEmpty(inquiryList) ? '질문 등록하기' : '수정하기'}
      onClick={() => {
        setModifyValue({ ...modifyValue, modifyStatus: 'question' });
      }}
    >
      {renderContents()}
    </ModifyContainer>
  );
};

export default QuestionContainer;
